<template>
  <ProductTable
    v-model="selected"
    :remove-cursor="true"
    newly-created-alert-key="product"

    title="Alle producten"
    table-layout-id="all-products"
    ref="product-table"

    @table-items="getSelectedProduct"
  >
    <template #new-item-alert-content="{name, sku}">
      U heeft een nieuw <router-link :to="`/admin/product/edit/${sku}`">{{ name }}</router-link> product.
    </template>

    <template #before-search-field="{showButton, refetch}">
      <div>
        <MultipleSelectOptions v-if="showButton" :options="editOptions(refetch)">
          <template #delete>
            <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
          </template>
          <template #enable>
            <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </template>
          <template #disable>
            <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </template>
        </MultipleSelectOptions>
      </div>
    </template>

    <template v-slot:empty-state>
      <EmptyStatePlaceholder

        title="Er zijn geen producten"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm4 14a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
        </svg>
      </EmptyStatePlaceholder>
    </template>

    <template #after-title>
      <HeaderButton
        buttonTypeClass="btn-outline-primary btn-primary-secondary-outline ml-3"
        style="padding: 11px 8px"
        @click.native="newProduct"
      >
        Product toevoegen
      </HeaderButton>
    </template>

    <template #row-action="{item, refetch}">
      <TableActionDropdown class="drop" :item="item" :options="options(item, freshRefetch)"/>
    </template>

  </ProductTable>

  <!-- <div class="col-xl-4">
    <ManageCategories id="manage-categories"
      title="Geen producten geselecteerd"
      description="Selecteer een product om de categorieën te beheren"

      :show-categories="!!selectedProduct"
      :product="selectedProductItem"
      :updateProduct="updateProduct"
      :loadProduct="loadProduct"
    />
  </div> -->
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate.vue'
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import FormButtonCheckbox from "src/components/Inputs/FormButtonCheckbox.vue"
import FormCheckbox from '../../components/Inputs/FormCheckbox.vue'
import FormCustomRadio from "/src/components/Inputs/FormCustomRadio.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import ProductTable from "src/components/Product/ProductTable/ProductTable.vue"
import Categories from "../Categories.vue"
import TableRightColumn from '../../layout/Table/TableRightColumn.vue'
import MultipleSelectOptions from '../../layout/Table/MultipleSelectOptions.vue'
// import ManageCategories from '../../layout/ManageCategories.vue'

import table from '../../mixins/table'

export default {
  metaInfo: {
    title: "Alle producten",
  },
  mixins: [
    table({
      params: {
        selectedProduct: null,
      },
    }),
  ],
  components: {
    MultipleSelectOptions,
    TableRightColumn,
    // ManageCategories,
    FormCustomRadio,
    Categories,
    TableSearchField,
    TableTemplate,
    TableActionDropdown,
    FormCheckbox,
    EmptyStatePlaceholder,
    ProductTable,
    FormButtonCheckbox,
    HeaderButton,
  },
  data() {
    return {
      selected: [],
      products: [],
    }
  },
  methods: {
    async updateProduct(productForm, productSku = this.selectedProduct) {
      await this.axios.put(`/api/products/${productSku}`, productForm)
    },
    async loadProduct() {
      await this.$refs["product-table"].refetch(true)
    },

    getSelectedProduct(items) {
      this.products = items
    },
    newProduct() {
      this.$router.push("/admin/product/new").catch(()=>{})
    },
    goToEditProductPage(product) {
      this.$router.push(`/admin/product/edit/${product.sku}`).catch(()=>{})
    },
    async deleteProduct(uid, freshRefetch) {
      if (
        await this.$handlePromise(
          this.axios.delete(`/api/products/${uid}`)
        )
      ) {
        this.$success("Product succesvol verwijderd!")
        freshRefetch()
      }
    },
    options(item, freshRefetch) {
      return ([
        {
          click: () => this.goToEditProductPage(item),
          id: "update-table-element",
          name: "Product bewerken",
          icon: "nc-icon nc-ruler-pencil",
        },
        {
          click: () => this.deleteProduct(item.sku, freshRefetch),
          id: "delete-table-element",
          name: "Product verwijderen",
          icon: "nc-icon nc-simple-remove",
        },
      ])
    },

    makeProductActive({sku, active}) {
      this.$handlePromise(async () => {
        await this.updateProduct({
          active: !active,
        }, sku)

        this.$success(
          active ?
            "Product succesvol gedeactiveerd!" :
            "successfully activated product!"
        )
      })
    },
    deleteSelected(refetch) {
      this.$confirmAction(
        async () => {
          if (await this.$handlePromise(
            Promise.all(
              this.selected.map(sku => this.axios.delete(`/api/products/${sku}`))
            )
          )) {
            this.$success("Producten verwijderd!")
            refetch()
          }
        },
        {
          title: "Geselecteerde producten verwijderen",
          description: `Weet je zeker dat je de <b>${this.selected.length}</b> geselecteerde producten wilt verwijderen?`,
          buttonSave: "Verwijder geselecteerde",
        },
      )
    },
    async enableSelected(refetch) {
      if (await this.$handlePromise(
        Promise.all(
          this.selected.map(sku => {
            return this.updateProduct({
              active: true,
            }, sku)
          })
        )
      )) {

        this.$success("Producten geactiveerd!")
        refetch()
      }
    },
    async disableSelected(refetch) {
      if (await this.$handlePromise(
        Promise.all(
          this.selected.map(sku => {
            return this.updateProduct({
              active: false,
            }, sku)
          })
        )
      )) {
        await refetch()
        this.$success("Producten geactiveerd!")
      }
    },
    editOptions(refetch) {
      return [
        {
          name: "Geselecteerd inschakelen",
          id: "enable-selected",
          action: () => this.enableSelected(refetch)
        },
        {
          name: "Producten uitschakelen",
          id: "disable-selected",
          action: () => this.disableSelected(refetch),
        },
        {
          name: "Verwijder geselecteerde",
          id: "delete-selected",
          action: () => this.deleteSelected(refetch)
        },
      ]
    },
  },
  computed: {
    selectedProductItem() {
      const selectedProduct = this.selectedProduct
      const products = this.products
      if (!selectedProduct) return;
      if (!products || !products.length || typeof products === "string") return;

      return products.find(prod => prod.sku === selectedProduct)
    },
    selectedCategories() {
      const item = this.selectedProductItem
      return (item && item.categories) || []
    },
    mainCategory() {
      return this.selectedCategories.find(cat => cat.parent_id === null)
    },
    subCategories() {
      return this.selectedCategories.filter(cat => cat.parent_id !== null)
    },
    table() {
      return this.$refs.table
    },
    capitalize() {
      return [false, false, false, false]
    },
  },
}

</script>

<style scoped>

.name-wrapper {
  color: currentColor;
}

.name-wrapper:hover {
  text-decoration: underline;
}

.product-select-radio {
  cursor: pointer;
}

.button-icon {
  transform: translateY(-1px);
}

.customize-layout {
  margin-right: 8px;
}
.drop {
  margin-top: -8px;
}

</style>
